import { Button } from '@domgen/base-design-system-2.0/atoms/Button';
import { useTranslation } from 'react-i18next';
import { MemoCheck } from '../../../assets/icons/MemoCheck';
import { useIsTenantFeatureEnabled } from '../../../hooks';

const styles = {
  container: 'grid grid-cols-1 md:@min-[42rem]/registration:grid-cols-2 gap-space-300 mt-space-500',
  accessProductDetails: {
    container:
      'flex flex-col items-center text-center rounded-radius-200 bg-primary-100 border-1 border-primary-200 gap-space-400 p-space-500 w-full',
    text: 'flex flex-row justify-start gap-space-400 items-center w-full text-left',
    icon: 'min-w-space-400',
  },
};

type ProductDetailsProps = {
  productDetailsLink?: string;
  accessProductDetailsOnClick: () => void;
  registerAnotherApplianceOnClick: () => void;
};

export const BottomPanel = ({
  productDetailsLink,
  accessProductDetailsOnClick,
  registerAnotherApplianceOnClick,
}: ProductDetailsProps) => {
  const { t } = useTranslation('confirmationPage');

  const isProductDetailsDisplayed = useIsTenantFeatureEnabled('productDetails');

  return (
    <div className={styles.container}>
      <div>
        <Button variant="outline" onClick={registerAnotherApplianceOnClick}>
          {t('registerAnotherAppliance')}
        </Button>
      </div>
      {isProductDetailsDisplayed && (
        <div className={styles.accessProductDetails.container}>
          <div className={styles.accessProductDetails.text}>
            <div className={styles.accessProductDetails.icon}>
              <MemoCheck />
            </div>
            <h6>{t('accessProductInformation')}</h6>
          </div>
          <Button
            variant="primary"
            onClick={accessProductDetailsOnClick}
            disabled={!productDetailsLink}
          >
            {t('accessProductDetails')}
          </Button>
        </div>
      )}
    </div>
  );
};
